// ===============================
// src/pages/admin/RecivedOffersAdminCar.jsx
// ===============================
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_DOMAIN } from "config";

import { Heading, Img, Button } from "../../components";
import AllOffersAdminLines from "../../components/AllOffersAdminLines";
import ApprovedOffersAdmin from "../../components/ApprovedOffersAdmin";

export default function RecivedOffersAdminCar() {
  const { id } = useParams(); // car id
  const [sp] = useSearchParams();
  const statusFromQuery = Number(sp.get("status") || 0) || null; // 1 / 2 / null

  const navigate = useNavigate();
  const location = useLocation();

  const [car, setCar] = useState(location.state?.car || null);
  const [offers, setOffers] = useState(location.state?.offers || []);
  const [loading, setLoading] = useState(!location.state?.offers);

  // מיון תאריך יורד
  const sortedOffers = useMemo(() => {
    const arr = Array.isArray(offers) ? [...offers] : [];
    arr.sort((a, b) => new Date(b.offerDate || 0).getTime() - new Date(a.offerDate || 0).getTime());
    return arr;
  }, [offers]);

  useEffect(() => {
    // אם הגענו מהמסך הקודם (יש state) — אין צורך ב־fetch
    if (location.state?.offers?.length) return;

    // אם רעננת את הדף / נכנסת ישירות — צריך למשוך מהשרת
    // ✅ אפשרות מומלצת: ליצור API ייעודי שמחזיר הצעות לרכב בודד
    // לדוגמה: GET /offer/getAdminOffersByCarId?car_id=ID&status=1|2|null
    //
    // אם אין לך API כזה עדיין — תגידי לי מה כן קיים אצלך בשרת,
    // ואני אתאים את הקריאה בדיוק למה שיש.

    let cancelled = false;

    const fetchByCar = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${API_DOMAIN}/offer/getAdminOffersByCarId`, {
          params: { car_id: Number(id), status: statusFromQuery },
        });

        if (cancelled) return;

        // מצופה: { car: {...}, offers: [...], images: [...] }
        const carObj = data?.car || null;
        const offersArr = data?.offers || [];

        setCar(carObj);
        setOffers(offersArr);
      } catch (e) {
        console.error(e);
        if (!cancelled) {
          setCar(null);
          setOffers([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchByCar();

    return () => {
      cancelled = true;
    };
  }, [id, statusFromQuery, location.state]);

  const tabTitle =
    statusFromQuery === 1 ? "הצעות חדשות" : statusFromQuery === 2 ? "הצעות שאושרו" : "כל ההצעות";

  return (
    <div className="flex bg-blue_gray-50 p-8 sm:p-4" style={{ width: "94%", paddingTop: "1rem" }}>
      <div className="w-[100%] items-start gap-4 md:flex-col" style={{ gap: "2%" }}>
        <div className="flex relative flex-1 flex-col gap-6 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4">
          <div className="flex items-center justify-between border-b border-solid border-gray-200 pb-4" dir="rtl">
            <div className="flex items-center gap-3">
              {/* דוגמה לתמונה כמו אצלך למעלה */}
              <Heading size="heading9xl" as="h4" className="!font-heebo text-[22px] font-bold">
            {/*    {tabTitle} */}
              </Heading>
            </div>

            <Button
              size="lg"
              shape="round"
              className="rounded-[16px] border border-solid border-gray-300 px-4 py-2 font-semibold bg-white"
              onClick={() => navigate(-1)}
            >
              חזרה
            </Button>
          </div>

          {loading ? (
            <div className="text-center text-gray-500 py-6">טוען...</div>
          ) : (
            <>
        
              {/* אותה טבלה בדיוק, אבל עם כל ההצעות */}
              {statusFromQuery === 2 ? (
                <ApprovedOffersAdmin car={car} rows={sortedOffers} />
              ) : (
                <AllOffersAdminLines car={car} rows={sortedOffers} />
              )}

              {/* אם אין הצעות */}
              {(!sortedOffers || sortedOffers.length === 0) && (
                <div className="text-center text-gray-500 py-6">אין הצעות להצגה</div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
